/* eslint-disable */
<template>
  <div>
    <img :src="closeIcon" alt @click="close" class="close-icon">
    <div class="preferences-modal">
      <employee-hub-service
        v-if="selectedDirectory"
        :platform-category="selectedDirectory"
        :service-id="serviceId"
        :current-user-access-token="authResponse.accessToken"
      />
      <employee-hub-service
        v-else
        :service-id="serviceId"
        :current-user-access-token="authResponse.accessToken"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const modalName = "manage-preferences-modal";

import Vue from "vue";
import * as CONSTANTS from "@/store/constants";
import { mapGetters, mapActions, mapMutations } from "vuex";
import closeIcon from "@/assets/close-icon.svg";

export default {
  name: modalName,
  data() {
    return {
      closeIcon
    };
  },
  props: {
    serviceId: String,
    directory: String,
    token: String
  },
  computed: {
    ...mapGetters(["authResponse"]),
    selectedDirectory() {
      return this.directory && this.directory == CONSTANTS.ALL_SERVICE_DIRECTORY ? "" : this.directory;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  watch: {
    $route(to, from) {
      window.location.href = "";
    }
  }
};
</script>

<style scoped>
.modal-header {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom: 0;
}
.close-icon {
  position: absolute;
  right: 3rem;
  top: 1.5rem;
  z-index: 2;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise-service-directory/EnterpriseServiceModal.vue